<div class="card-level-info-display">
  <a [routerLink]="['/home/syllabus/info',levelPrimaryOneInfo.syllabusCode]">
    <img [src]="imageFullPath" [alt]="imageDescription" style="width:98%">
  </a>
    <div class="container" *ngIf="iData">
      <h4>
        <app-country-flag *ngIf="iData" [countryImage]="iData.countryImage"></app-country-flag>
         <b> Mathematics {{iData['primaryLevelNaming']}} {{gradeLevel}}</b></h4>
      <p>{{levelPrimaryOneInfo.topicCount}} Topics, {{levelPrimaryOneInfo.subTopicCount}} Subtopics </p>
      <table class="table">
        <tr>
          <td class="align-middle" ><a [routerLink]="['/home/syllabus/info',levelPrimaryOneInfo.syllabusCode]" class="btn btn-outline-primary">More info</a></td>
          <td><button (click)="downloadapp()" type="button" class="btn btn-outline-primary">Get App</button></td>
          <td class="align-middle"  *ngIf="!gatePass.is_logged_in"> <a [routerLink]="['/user/new/step/one']" class="btn btn-outline-primary"> Enrol Now</a></td>
          <td class="align-middle"  *ngIf="gatePass.is_logged_in"><a routerLink="home/show" class="btn btn-outline-primary"> Enrol Now</a></td>
        </tr>
      </table>
    </div>
</div>
